
        var result = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ngx-pagination-bootstrap.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/components/ngx-pagination-bootstrap-component/ngx-pagination-bootstrap.component.scss
// module id = 6
// module chunks = 0 1